import { SettingsHeader } from '../components/SettingsHeader';
import { Backend } from '../../../api/Backend';
import { ScrollList } from '../../../components/shared/ScrollList';

export class SettingsSection {
  protected backend: Backend;
  private readonly title: string;

  constructor(backend: Backend, title: string) {
    this.backend = backend;
    this.title = title;
  }

  addControls(list: ScrollList) {
    list.items.childList.a({
      type: SettingsHeader,
      data: {
        title: this.title,
      },
    });
  }
}
